module.exports = __webpack_public_path__ + "media/ft.3ceeff4c.mp4";